import React, { useEffect } from 'react';

import BasePage from 'apps/auth/components/utils/BasePage';
import Spinner from 'apps/auth/components/utils/Spinner/Spinner';
import { LOGIN } from 'apps/auth/constants/UrlConstants';
import { timer } from 'apps/auth/helpers/utils';

const EmailRedirect = () => {
    useEffect(() => {
        timer(
            null,
            () => {
                window.location.href = LOGIN;
            },
            1000,
        );
    }, []);

    return <Spinner forceShow={true} isEmptyText />;
};

export default BasePage(EmailRedirect);
